export enum TransactionType {
  'TASK' = 'TASK',
  'WORKFLOW' = 'WORKFLOW',
}
